import { render, staticRenderFns } from "./setDormDeviceIdForm.vue?vue&type=template&id=4a60edb2&scoped=true&"
import script from "./setDormDeviceIdForm.vue?vue&type=script&lang=js&"
export * from "./setDormDeviceIdForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a60edb2",
  null
  
)

export default component.exports